/* eslint-disable no-restricted-syntax */
export const convertUndefinedToNull = (data: any): any => {
  if (data == null || typeof data !== 'object' || Array.isArray(data)) {
    return data === undefined ? undefined : data;
  }

  const result: any = {};
  for (const [key, value] of Object.entries(data)) {
    result[key] = value === undefined ? null : value;
  }
  return result;
};
